import { graphql } from 'parkdepot-shared/gql'

export const GET_LOT_WITH_ID = graphql(`
    query booking_get_lot($lot_id: String!) {
        booking_get_lot(lot_id: $lot_id) {
            id
            is_live
            name
            address
            description
            opening_hours {
                opening_hours_rrules {
                    duration
                    rrule
                }
            }
            prices {
                day
                hour
                month
                week
                pricing_type
            }
            active_features {
                config
                enabled
                name
            }
            earliest_booking_date
            end_of_live_date
            lot_country_code
            min_booking_duration
            max_booking_duration
        }
    }
`)
